import axios from "@/config/http";
import ip from "../config/ip.js";

let base = ip.Ips.ip1;

/**
 * 门店活动-查询
 * @param {*} params
 * @returns
 */
export function storeActivityPage(params) {
  return axios.get(`${base}/store/activity/page`, { params: params });
}
/**
 * 门店活动-详情
 * @param {*} id
 * @returns
 */
export function storeActivityInfo(id) {
  return axios.get(`${base}/store/activity/info`, { params: { id: id } });
}
/**
 * 门店活动-新增/更新
 * @param {*} data
 * @returns
 */
export function storeActivitySave(data) {
  return axios.post(`${base}/store/activity/save`, data);
}
/**
 * 门店优惠券-查询
 * @param {*} params
 * @returns
 */
export function storeCouponList(params) {
  return axios.get(`${base}/store/coupon/list`, { params: params });
}
/**
 * 门店优惠券-分页
 * @param {*} params
 * @returns
 */
export function storeCouponPage(params) {
  return axios.get(`${base}/store/coupon/page`, { params: params });
}
/**
 * 门店优惠券-详情
 * @param {*} id
 * @returns
 */
export function storeCouponInfo(id) {
  return axios.get(`${base}/store/coupon/info`, { params: { id: id } });
}
/**
 * 门店优惠券-新增
 * @param {*} data
 * @returns
 */
export function storeCouponSave(data) {
  return axios.post(`${base}/store/coupon/save`, data);
}
/**
 * 门店优惠券-更新
 * @param {*} data
 * @returns
 */
export function storeCouponUpdate(data) {
  return axios.post(`${base}/store/coupon/update`, data);
}

/**
 * 门店优惠券-会员优惠券-分页
 * @param {*} params
 * @returns
 */
export function storeSubscriberCouponPage(params) {
  return axios.get(`${base}/store/subscriber/coupon/page`, { params: params });
}



// WEBPACK FOOTER //
// ./src/api/store.js